import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'epa-item-card',
  templateUrl: './epa-item-card.component.html',
  styleUrls: ['./epa-item-card.component.scss']
})
export class EpaItemCardComponent {
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() actionIconName: string = '';
  @Input() actionLabel: string = '';
  @Input() clickable: boolean = false;
  @Input() variant: 'red' | 'green' = 'red';

  @Output() cardClick = new EventEmitter<string>();

  onClick(): void {
    if (this.clickable) {
      this.cardClick.emit(this.value);
    }
  }
}
